/**
 * InlineMessages
 *
 * Messages that appear for more information: info, warning, error messages.
 * USAGE:
 * - Make sure to load styleguide colors and typography when using.
 */
import * as React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import keysToConstants from 'js/lib/keysToConstants';

/** **************************************************************************
 * Dumb Component
 * ************************************************************************** */
import 'css!./__styles__/InlineMessage';

/** **************************************************************************
 * All the supported MessageTypes. Add an entry here if adding a message type.
 * ************************************************************************** */
const MessageTypes = keysToConstants(['SERVER_ERROR_TYPE', 'ERROR_TYPE', 'SUCCESS_TYPE', 'WARNING_TYPE']);

class InlineMessage extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(Object.keys(MessageTypes)).isRequired,
    contents: PropTypes.oneOfType([
      PropTypes.string,

      PropTypes.shape({
        status: PropTypes.oneOf([400, 401, 402, 403, 500]),
        responseJSON: PropTypes.shape({
          errors: PropTypes.arrayOf(
            PropTypes.shape({
              errorCode: PropTypes.string.isRequired,
              fieldName: PropTypes.string.isRequired,
              msg: PropTypes.string.isRequired,
              details: PropTypes.object,
            })
          ),
          message: PropTypes.string,
        }).isRequired,
      }),
    ]).isRequired,
    className: PropTypes.string,
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'type' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    const { type, contents } = this.props;

    let processedContents;
    if (type === MessageTypes.SERVER_ERROR_TYPE) {
      if (contents?.responseJSON?.errors) {
        processedContents = contents.responseJSON.errors.map((error: $TSFixMe) => (
          <li key={error.errorCode}>
            <span className="body-2-text">{error.fieldName}</span>
            &nbsp;threw error&nbsp;
            <span className="body-2-text">{error.errorCode}</span>
            &nbsp;with message:&nbsp;
            <span className="body-2-text">{error.msg}</span>
          </li>
        ));
      } else {
        processedContents = contents?.responseJSON?.message ?? '';
      }
    } else {
      processedContents = contents;
    }

    return (
      <div
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'className' does not exist on type 'Reado... Remove this comment to see the full error message
        className={classNames('rc-InlineMessage', this.props.className, {
          error: type === MessageTypes.SERVER_ERROR_TYPE || type === MessageTypes.ERROR_TYPE,
          success: type === MessageTypes.SUCCESS_TYPE,
          warning: type === MessageTypes.WARNING_TYPE,
        })}
      >
        {processedContents}
      </div>
    );
  }
}

export { MessageTypes, InlineMessage };
